package com.klantenstop.web.data.models.dto.requests

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ResetPasswordDto(
    val token: String,
    val password: String,
    @SerialName("repeat_password")
    val repeatPassword: String
)

